import clsx from 'clsx';
import { h } from 'preact';

const SPDVideoControl = ({ toggleType, handleClick, isActive, className }) => {
  const isPause = toggleType === 'pause';
  let Icon;
  let ariaLabel;

  const renderPauseIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <path d="M7 4a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h2zM15 4a1 1 0 011 1v10a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2z" />
    </svg>
  );

  const renderPlayIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <polygon points="5,3 5,17 17,10" />
    </svg>
  );

  const renderVolumeIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.617.784L4.357 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.357l4.026-3.784a1 1 0 011.617-.784zM7.5 6.5L4.357 9H2v2h2.357L7.5 13.5v-7zm6.207 2.293a1 1 0 011.414 0L16 9.5l.879-.707a1 1 0 111.414 1.414L17.414 10.5l.879.707a1 1 0 01-1.414 1.414L16 11.914l-.879.707a1 1 0 01-1.414-1.414l.879-.707-.879-.707a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );

  const renderMuteIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.617.784L4.357 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.357l4.026-3.784a1 1 0 011.617-.784zM7.5 6.5L4.357 9H2v2h2.357L7.5 13.5v-7zm4.5 0a1 1 0 011.414 0 5 5 0 010 7.071A1 1 0 0111.5 12.5a3 3 0 000-4.242A1 1 0 0112 6.5z"
        clipRule="evenodd"
      />
    </svg>
  );

  if (isPause) {
    Icon = isActive ? renderPauseIcon : renderPlayIcon;
    ariaLabel = isActive ? 'Pause video' : 'Play video';
  } else {
    Icon = isActive ? renderVolumeIcon : renderMuteIcon;
    ariaLabel = isActive ? 'Mute video' : 'Unmute video';
  }

  return (
    <button
      type="button"
      data-video-control={toggleType}
      onClick={handleClick}
      className={clsx(
        'w-[30px] h-[30px] border border-white flex items-center justify-center text-white hover:bg-white/20 transition-colors focus:ring-2 focus:ring-white/30 focus:outline-none',
        className,
      )}
      aria-label={ariaLabel}
    >
      <Icon />
    </button>
  );
};

export default SPDVideoControl;
